import Vue from 'vue'


export const global = {


    setup:function(vm){
        Vue.prototype.$globalData.pagesShow =  {
            list: true,
            edit: false,
          };
          vm.pagesShow = Vue.prototype.$globalData.pagesShow;
          console.log( vm.$globalData.pagesShow);
          vm.backAction = function(){
              console.log('backAction');
            vm.$globalData.pagesShow.list = true;
            vm.$globalData.pagesShow.edit = false;
          };
    },
    backAction:function(){
        if ( Vue.prototype?.$globalData?.pagesShow?.list == null) return
        Vue.prototype.$globalData.pagesShow.list = true;
        Vue.prototype.$globalData.pagesShow.edit = false;
    },
    needShowBackBtn:function(){
        if ( Vue.prototype?.$globalData?.pagesShow?.list == null) return false
        return Vue.prototype.$globalData.pagesShow.list == false;
    },
    
    test:function(){
        console.log('aaa');
    }

}

